import React, { Component } from "react";
import {
  Wrapper,
  Card,
  Input,
  CardBody,
  Copy
} from "app/NativeComponents/common";

class Inputs extends Component {
  render() {
    return (
      <Wrapper>
        <Card>
          <Input
            ref={"company_name"}
            name={"company_name"}
            placeholder={"Company Name"}
            onChange={value => {
              this.props.updatePartnerInfo({ value, prop: "company_name" });
            }}
            value={this.props.editPartnerInfo.company_name}
            type="text"
          />
          <Input
            ref={"company_website"}
            name={"company_website"}
            placeholder={"Company Website"}
            onChange={value => {
              this.props.updatePartnerInfo({ value, prop: "company_website" });
            }}
            value={this.props.editPartnerInfo.company_website}
            type="text"
          />
        </Card>

        <CardBody>
          <Copy>
            We'll need a paypal email address in order to issue payments to you!
            Please make sure this email address is correct!
          </Copy>
        </CardBody>
        <Card>
          <Input
            ref={"paypal_email"}
            name={"paypal_email"}
            placeholder={"PayPal Email Address"}
            onChange={value => {
              this.props.updatePartnerInfo({ value, prop: "paypal_email" });
            }}
            value={this.props.editPartnerInfo.paypal_email}
            type="text"
          />
        </Card>
      </Wrapper>
    );
  }
}

export default Inputs;
